import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SuccessModal } from 'src/app/app.model';

type ResultIntent = 'success' | 'info' | 'error';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.css']
})
export class SuccessModalComponent implements OnInit {
  @Input() data: SuccessModal = {
    message: '',
    image: '',
    duration: 0,
  };

  constructor(private activeModalService: NgbActiveModal) {}

  ngOnInit(): void {
    // Auto-dismiss is now an optional convenience only: a falsy/0 duration keeps
    // the modal open until the user closes it via the Done button or the X.
    if (this.data.duration) {
      setTimeout(() => this.activeModalService.close(), this.data.duration);
    }
  }

  get intent(): ResultIntent {
    return this.data.intent || 'success';
  }

  get iconClass(): string {
    switch (this.intent) {
      case 'error': return 'bi-exclamation-lg';
      case 'info': return 'bi-info-lg';
      default: return 'bi-check-lg';
    }
  }

  onDone() {
    this.activeModalService.close();
  }

  onSecondary() {
    this.activeModalService.close('secondary');
  }
}
